(ns common.chart-tooltip)

(defn placement
  "Where a chart's tooltip sits within it, in pixels from its top left: centred
   over the hovered column and `gap` above the pointer, pulled back inside the
   chart wherever it would otherwise overhang an edge. Box measurements are the
   viewport coordinates the browser reports."
  [{:keys [chart-left chart-top chart-width
           column-left column-width
           tooltip-width tooltip-height
           pointer-y gap]}]
  (let [column-mid (- (+ column-left (/ column-width 2))
                      chart-left)
        rightmost  (max 0 (- chart-width tooltip-width))]
    {:left (min rightmost
                (max 0 (- column-mid (/ tooltip-width 2))))
     :top  (max 0 (- pointer-y chart-top tooltip-height gap))}))
